module.exports = "//docs.gtimg.com/slide/img/slide/application/service/slide-rating-and-improve/view/pc/start/blankpage_search-a2dabb.svg";